import { render, staticRenderFns } from "./HealthCheckViewSetting.vue?vue&type=template&id=8b0adac6&"
import script from "./HealthCheckViewSetting.vue?vue&type=script&lang=js&"
export * from "./HealthCheckViewSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports